import React from 'react';

const NormUserIcon = ({ className = "h-5 w-5 text-white" }) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" stroke="currentColor" strokeWidth="2" strokeLinecap="square">
      <path d="M0 18c0-4.52 3.663-8.182 8.182-8.182h1.636C14.337 9.818 18 13.481 18 18" />
      <circle cx="9" cy="4.909" r="4.909" />
    </g>
  </svg>
);

export default NormUserIcon;
